import { render, staticRenderFns } from "./GridFullWidth.vue?vue&type=template&id=e0d72a82&"
import script from "./GridFullWidth.vue?vue&type=script&lang=js&"
export * from "./GridFullWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports